import React, { FunctionComponent } from "react";
import { Alert, Col, Row } from "react-bootstrap";

import BoySvg from "./assets/boy.svg?react";
import DownloadSvg from "./assets/download-svgrepo-com.svg?react";
import DocumentSvg from "./assets/document-svgrepo-com.svg?react";
import ToolsSvg from "./assets/tools-svgrepo-com.svg?react";
import GeniusSvg from "./assets/genius-svgrepo-com.svg?react";
import { useAuthentication } from "../../hooks/useAuthentication";
import useSubscription from "../../hooks/useSubscription";
import { ContentLayout } from "../common/Layout";
import { useUserIdParam } from "../../hooks/useUserIdParam";
import "./SpielgruppePlus.scss";

interface Props {
  isAuthenticated: boolean;
}

export const SpielgruppePlus: FunctionComponent<Props> = ({ isAuthenticated }) => {
  const userId = useUserIdParam();
  const subscription = useSubscription(userId);
  useAuthentication(isAuthenticated);

  const isPlusSubscription = subscription?.role === "Spielgruppe Plus";

  return (
    <ContentLayout title={"Spielgruppe Plus"} siteTitle={"Spielgruppe Onlie - Spielgruppe Plus"}>
      {isPlusSubscription && (
        <Alert className={"mt-5"} variant={"info"}>
          <b>Sie besitzen eine aktive Spielgruppe Plus Mitgliedschaft.</b>
          <br />
        </Alert>
      )}
      <Row className={"mt-5"}>
        <Col sm={12} md={9}>
          <Row>
            <Col md={5} className={"pb-5"}>
              <h3>Anmeldungsexport</h3>
              <p>Eingegangene Anmeldungen können ganz bequem als Excel-Liste exportiert werden.</p>
            </Col>
            <Col md={2} className={"mt-5 pb-5 d-none d-md-block"}>
              <div className="top-dot" />
              <div className="vertical-line" />
            </Col>
            <Col md={5} className={"mt-5 d-none d-md-flex"}>
              <DownloadSvg />
            </Col>
          </Row>
          <Row>
            <Col className={"flex-row-reverse align-items-center d-none d-md-flex"} md={5}>
              <DocumentSvg />
            </Col>
            <Col className={"d-none d-md-block"}>
              <div className="center-dot" />
              <div className="vertical-line" />
            </Col>
            <Col md={5} className={"py-5"}>
              <h3>Zusätzliche Formularfelder</h3>
              <p>
                Diverse zusätzliche Feldtypen stehen zur Verfügung. E-Mail, Ganzzahlen, Checkboxen, Zwischentitel, etc.
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={5} className={"py-5"}>
              <h3>Individuelle E-Mail-Gestaltung</h3>
              <p>
                Gestalten Sie Ihre generierten E-Mails nach belieben. Passen Sie Text und Farben an Ihre Spielgruppe an.
              </p>
            </Col>
            <Col className={"d-none d-md-block"}>
              <div className="center-dot" />
              <div className="vertical-line" />
            </Col>
            <Col md={5} className={"flex-row align-items-center d-none d-md-flex"}>
              <ToolsSvg />
            </Col>
          </Row>
          <Row>
            <Col md={5} className={"flex-row-reverse align-items-end mb-4 d-none d-md-flex"}>
              <GeniusSvg />
            </Col>
            <Col className={"mb-5 d-none d-md-block"}>
              <div className="bottom-dot" />
              <div className="vertical-line" />
            </Col>
            <Col md={5} className={"pt-5"}>
              <h3>Viele weitere Funktionen folgen</h3>
              <p>Wir entwickeln laufend zusätzliche Module, welche unseren Spielgruppen das Leben erleichtern.</p>
            </Col>
          </Row>
          <Row className={"pt-5"}>
            <Col md={4} />
            <Col md={4}>
              Melden Sie sich bei uns unter <strong>info@webtie.ch </strong> um auf <strong>Spielgruppe Plus</strong> zu
              wechseln.
            </Col>
            <Col md={4} />
          </Row>
        </Col>
        <Col sm={12} md={3} className={"d-none d-md-block"}>
          <BoySvg />
        </Col>
      </Row>
    </ContentLayout>
  );
};
